import type { HandRecord, TableSnapshot } from '@tctp/protocol';
import { logLines } from '../logLines';

const hhmm = (t: number): string => new Date(t).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

export function FullLogTab({ snapshot, history, roomId, onReplay }: { snapshot: TableSnapshot; history: HandRecord[]; roomId: string; onReplay: (r: HandRecord) => void }) {
  const lines = logLines(history, snapshot.hand, snapshot.seats, snapshot.config.smallBlind);
  return (
    <>
      <div className="log-list">
        {lines.length === 0 && <p className="muted">No hands yet.</p>}
        {lines.map((l, i) => {
          const record = l.handId ? history.find(r => r.handId === l.handId) : undefined;
          return (
            <div key={i} className={`log-line ${l.tone}`}>
              <span className="log-time">{hhmm(l.t)}</span><span>{l.text}</span>
              {record && <button type="button" className="hb-replay small" onClick={() => onReplay(record)}>▶ REPLAY</button>}
            </div>
          );
        })}
      </div>
      <div className="session-foot"><a className="btn green" href={`/api/rooms/${roomId}/handlog.json`} download>DOWNLOAD</a></div>
    </>
  );
}
